const DEFAULT_BASE_URLS: Record<string, string> = {
  misterbooking: "https://api.misterbooking.com",
};

function normalizeConnectorKey(value: string): string {
  return value.toLowerCase().replace(/[\s_-]/g, "");
}

export function getDefaultPmsBaseUrl(connector: {
  code?: string;
  name?: string;
  cloudified?: boolean;
}): string | undefined {
  if (connector.cloudified) {
    return undefined;
  }

  const code = normalizeConnectorKey(connector.code || "");
  const name = normalizeConnectorKey(connector.name || "");
  return DEFAULT_BASE_URLS[code] || DEFAULT_BASE_URLS[name];
}
